import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import moment from "moment";
import axios from "axios";

import { MdOutlineNavigateNext } from "react-icons/md";

import MediaViewer from "../../../../../../common/mediaViewer";

import { ProjectDetailFiles, ProjectDetailSection } from "../../common/styled/project";
import { useModal } from "../../../../../../hooks/useModal";
import { openAdmin } from "../../../../dashboard/component/function/dashboard";

const Files = ({ project }) => {
  const navigate = useNavigate();

  const { modal, openModal, closeModal } = useModal();
  const user = useSelector((state) => state?.user?.data[0]);

  const { projectNo } = useParams();

  const [folderState, setFolderState] = useState("");
  const [files, setFiles] = useState({ I: {}, V: {}, F: {} });
  const [counts, setCounts] = useState({});
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDetail, setIsDetail] = useState(false);
  const [imageOrder, setImageOrder] = useState([]);

  let globalIndex = 0;

  useEffect(() => {
    getFiles();
  }, []);

  // 파일 조회
  const getFiles = async () => {
    const url = "/api/fileList";
    const body = {
      projectNo,
      delYn: "N",
      offset: 0,
      pageNumber: 0,
      pageSize: 10,
      paged: false,
    };

    const res = await axios.post(url, body);
    if (res.status === 200) {
      console.log(res);
      splitFiles(res.data);
    }
  };

  // 이미지, 동영상, 파일 분리
  const splitFiles = async (data) => {
    const splitData = { I: {}, V: {}, F: {} };
    const count = { I: 0, V: 0, F: 0 };

    data.forEach((file) => {
      if (splitData.hasOwnProperty(file.fileType)) {
        const date = moment(file.createDt).format("YYYY-MM-DD");
        if (!splitData[file.fileType][date]) {
          splitData[file.fileType][date] = [];
        }
        splitData[file.fileType][date].push(file);
        count[file.fileType] += 1;
      }
    });

    setCounts(count);
    setFiles(splitData);
  };

  // 사진, 동영상, 파일 폴더 선택
  const changeFolder = (newFolder) => {
    setFolderState(newFolder);
    setSelectedFiles([]);
  };

  const folders = [
    { key: "I", name: "사진" },
    { key: "V", name: "동영상" },
    { key: "F", name: "파일" },
  ];

  const isFolderState = () => {
    if (!project.projectNm) return null;
    if (folderState) {
      const name = folders.find((f) => f.key === folderState)?.name;

      return (
        <>
          <span onClick={revertToPreviousFolder} style={{ cursor: "pointer" }}>
            {project.projectNm}
          </span>
          <span className="icon">
            <MdOutlineNavigateNext />
          </span>
          <span>{name}</span>
        </>
      );
    } else {
      return <span>{project.projectNm}</span>;
    }
  };

  const isFileType = (item) => {
    if (folderState === "I") {
      return <img src={imgHandler(item.filePath, false)} />;
    }
    if (folderState === "F") {
      return (
        <>
          <img src="/img/file.png" style={{ height: `calc(100% - 18px)` }} />
        </>
      );
    }
    if (folderState === "V") {
      return <img src="/img/video.png" />;
    }
  };

  // 파일 선택/해제
  const toggleFileItem = (file) => {
    setSelectedFiles((item) => {
      if (item.includes(file)) {
        return item.filter((item) => item !== file);
      } else {
        return [...item, file];
      }
    });
  };

  // 전체 파일 선택/해제
  const handleAllCheckboxClick = (data, isChecked) => {
    const allFiles = data.flat();
    if (isChecked) {
      setSelectedFiles((prevSelectedFiles) => [...new Set([...prevSelectedFiles, ...allFiles])]);
    } else {
      setSelectedFiles((prevSelectedFiles) =>
        prevSelectedFiles.filter((file) => !allFiles.includes(file)),
      );
    }
  };
  // 뒤로가기
  const revertToPreviousFolder = () => {
    setFolderState("");
    setSelectedFiles([]);
  };

  // 이미지 클릭
  const handleImageClick = (item) => {
    if (folderState === "F") return;

    setIsDetail(true);

    const flatImages = Object.values(files[folderState]).flat(2);
    const index = flatImages.findIndex((image) => image.projectFileNo === item.projectFileNo);

    if (index === -1) return;

    const images = flatImages.map((item) => ({
      path: item.filePath,
      createNm: item.mberNm,
      createDt: item.createDt,
      photoNo: item.projectFileNo,
      refeNo: item.scheduleNo || null,
    }));

    const reorderedImages = [...images.slice(index, images.length), ...images.slice(0, index)];
    setImageOrder(reorderedImages);
  };

  const totalImageCount = useMemo(() => {
    if (!files[folderState]) return 0;
    return Object.values(files[folderState]).flat().length;
  }, [files, folderState]);

  return (
    <ProjectDetailSection>
      {modal}
      <ProjectDetailFiles>
        <div className="filesHeader">
          <div className="filePath">{isFolderState()}</div>
          {folderState && selectedFiles.length > 0 && (
            <div className="fileButtons">
              {folderState === "I" && (
                <button
                  onClick={() =>
                    openModal({
                      isOpen: true,
                      type: "confirmation",
                      title: `포트폴리오`,
                      message: [`포트폴리오로 전송하시겠습니까?`],
                      handleConfirm: () => {
                        openAdmin(user, { type: "PORTFOLIO_IMAGES", payload: selectedFiles });
                        closeModal();
                      },
                      handleCancel: () => closeModal(),
                    })
                  }>
                  포트폴리오 전송
                </button>
              )}
              <button onClick={() => alert("준비 중입니다.")}>내려받기</button>
            </div>
          )}
        </div>
        <ul className="folders">
          {folders.map((item) => (
            <li
              key={item.key}
              onClick={() => changeFolder(item.key)}
              className={item.key === folderState ? "active" : ""}>
              <span>{item.name}</span>
              {counts[item.key] > 0 && <i>&#40;{counts[item.key]}&#41;</i>}
            </li>
          ))}
        </ul>
        <div className="filesContainer">
          {files[folderState] &&
            Object.entries(files[folderState]).map(([date, data]) => (
              <div key={date} className="dateGroup">
                <div className="dateHeader">
                  <input
                    type="checkbox"
                    checked={data.every((item) => selectedFiles.includes(item))}
                    onChange={(e) => handleAllCheckboxClick(data, e.target.checked)}
                  />
                  <span>{date}</span>
                </div>
                {data.length > 0 && (
                  <ul className="fileGroup">
                    {data.map((item, idx) => {
                      const reverseIndex = totalImageCount - globalIndex++;

                      return (
                        <li
                          key={idx}
                          className="fileItem"
                          data-path={item.filePath}
                          onClick={() => handleImageClick(item)}>
                          <div className="preview">{isFileType(item)}</div>
                          <p className="comment">
                            {folderState === "I" && <strong>{reverseIndex}</strong>}
                            {folderState === "F" ? (
                              <span>{item.fileNm}</span>
                            ) : folderState === "I" ? (
                              <span>{item?.lastComment}</span>
                            ) : null}
                          </p>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleFileItem(item);
                            }}
                            className="selected">
                            {selectedFiles.includes(item) && (
                              <i>{selectedFiles.indexOf(item) + 1}</i>
                            )}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            ))}
        </div>
        {isDetail && (
          <MediaViewer
            files={imageOrder}
            setIsOpen={setIsDetail}
            isComment={true}
            getImages={getFiles}
          />
        )}
      </ProjectDetailFiles>
    </ProjectDetailSection>
  );
};

export default Files;
